import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7e6ff9d1")
const _hoisted_1 = { class: "get-code" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("獲取驗證碼")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, { "label-width": "60px" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "手機號",
        prop: "num"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.phone.num,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.phone.num = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "驗證碼",
        prop: "code"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.phone.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.phone.code = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "get-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}